import React, {useEffect, useState, useContext} from 'react'
import {ListadoOrdenesYAtenciones} from '../../../componentes/RecursosHumanos'
import {useMsal} from '@azure/msal-react'
import {TEXTO_VISUAL} from '../../../constantes'
import {FachadaObtenerAtencionesGestionAtenciones} from '../../../microservicios'
import {ObtenerEmpresasUsuarioB2c} from '../../../microservicios/UsuarioB2c'
import moment from 'moment'
import {
  ObtenerEmpresaPadreYempresasHijas,
  ObtenerTodasLasSedes,
  ObtenerConceptosDeAptitud,
} from '../../../cache/servicios-cache'
import {ordenarListaOrdenes, agregarFormatoFecha} from '../../../utils'
import {ContextoAplicacion} from '../../../contexto'

const GestionAtenciones = () => {
  const {accounts} = useMsal()
  const contextoAplicacion = useContext(ContextoAplicacion)
  const rolUsuario = accounts[0].idTokenClaims?.country ?? ''
  const esMedico = rolUsuario === TEXTO_VISUAL.HOME.ROL.MEDICO
  const [empresasIds, setEmpresasIds] = useState([])
  const [empresasCargadas, setEmpresasCargadas] = useState(false)

  useEffect(() => {
    if (!esMedico) {
      setEmpresasCargadas(true)
      return
    }

    const obtenerEmpresasDelMedico = async () => {
      try {
        const response = await ObtenerEmpresasUsuarioB2c(
          accounts[0].idTokenClaims?.oid ?? ''
        )
        setEmpresasIds(
          response.status === 200
            ? response.data.map((empresa) => empresa.empresaId)
            : []
        )
      } catch (error) {
        console.error('Error al obtener empresas del médico:', error)
        setEmpresasIds([])
      } finally {
        setEmpresasCargadas(true)
      }
    }

    obtenerEmpresasDelMedico()
  }, [accounts, esMedico])
  const idEmpresa = contextoAplicacion.infoEmpresa.id ?? 0
  const [listaOrdenes, setListaOrdenes] = useState([])

  const filtrosIniciales = {
    tamano: 10,
    pagina: 1,
    filtros: {
      centroCostosId: null,
      documento: '',
      conceptoId: '',
      nombres: '',
      apellidos: '',
      fechaDesde: moment().format('YYYY-MM-DD 00:00:00'),
      fechaHasta: moment().format('YYYY-MM-DD HH:mm:ss'),
      estadoId: '',
      sedeId: '',
      usuariosIds: [],
      empresasIds: [],
    },
  }

  const [dataFiltros, setDataFiltros] = useState(filtrosIniciales)
  const [actualizarInformacion, setActualizarInformacion] = useState(true)
  const [informacionPaginacion, setInformacionpaginacion] = useState({})
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState('')
  const [empresasFiltradas, setEmpresasFiltradas] = useState([])
  const [estadosAtencion, setEstadosAtencion] = useState([])
  const [sedesCendiatra, setSedesSendiatra] = useState([])
  const [conceptosOrden, setConceptosOrden] = useState([])

  const ordenarAlfabeticamente = (array) => {
    if (array) {
      return array.sort((a, b) => {
        return a.Nombre.localeCompare(b.Nombre, 'es', {sensitivity: 'base'})
      })
    }
  }

  const obtenerInformacionInicial = async () => {
    try {
      const estadosAtenciones = [
        {
          Id: 3,
          Nombre: 'Atendida',
        },
        {
          Id: 2,
          Nombre: 'En Proceso',
        },
      ]

      const todosLosConceptos = await ObtenerConceptosDeAptitud()
      const todasLasSedes = await ObtenerTodasLasSedes()
      setEstadosAtencion(estadosAtenciones)
      setSedesSendiatra(ordenarAlfabeticamente(todasLasSedes))
      setConceptosOrden(todosLosConceptos)

      const payload = {
        filtros: {
          centroCostosId: dataFiltros.filtros.centroCostosId,
          conceptoId: dataFiltros.filtros.conceptoId,
          documento: dataFiltros.filtros.documento,
          nombres: dataFiltros.filtros.nombres,
          apellidos: dataFiltros.filtros.apellidos,
          empresasIds: dataFiltros.filtros.empresasIds.length
            ? dataFiltros.filtros.empresasIds
            : esMedico
            ? empresasIds
            : [idEmpresa],
          estadoId: dataFiltros.filtros.estadoId,
          fechaDesde:
            dataFiltros.filtros.documento ||
            dataFiltros.filtros.nombres ||
            dataFiltros.filtros.apellidos
              ? ''
              : dataFiltros.filtros.fechaDesde,
          fechaHasta:
            dataFiltros.filtros.documento ||
            dataFiltros.filtros.nombres ||
            dataFiltros.filtros.apellidos
              ? ''
              : dataFiltros.filtros.fechaHasta,
          sedeId: dataFiltros.filtros.sedeId,
          usuariosIds: dataFiltros.filtros.usuariosIds,
        },
        pagina: dataFiltros.pagina,
        tamano: dataFiltros.tamano,
      }
      // Un médico sin empresas asignadas no debe ver nada (una lista vacía podría interpretarse como "todas")
      if (esMedico && payload.filtros.empresasIds.length === 0) {
        setListaOrdenes([])
        return
      }

      let ordenes = await FachadaObtenerAtencionesGestionAtenciones(payload)
      if (esMedico && ordenes?.data) {
        let ordenesFiltradas = ordenes?.listaDeOrdenes.filter(
          (element) => element.estado === TEXTO_VISUAL.ORDENES.ESTADO.ATENDIDA
        )
        setListaOrdenes(ordenesFiltradas)
      } else {
        setListaOrdenes(ordenarListaOrdenes(ordenes?.listaDeOrdenes) ?? [])
      }
      setInformacionpaginacion(ordenes?.informacionPaginacion)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (idEmpresa && empresasCargadas) {
      obtenerInformacionInicial().catch(console.error)
    }
  }, [actualizarInformacion, dataFiltros.pagina, idEmpresa, empresasCargadas])

  const manejarCambioEnFiltro = (e) => {
    setDataFiltros((prev) => {
      return {
        ...prev,
        pagina: 1,
        filtros: {
          ...prev.filtros,
          [e.target.name]: agregarFormatoFecha(e),
        },
      }
    })
  }
  const filtrarEmpresas = async (e) => {
    setEmpresaSeleccionada({
      ...empresaSeleccionada,
      nombreEmpresa: e.target.value,
    })
    if (e.target.value.length >= 2) {
      ObtenerEmpresaPadreYempresasHijas(idEmpresa, e.target.value).then(
        (res) => {
          setEmpresasFiltradas(res)
        }
      )
    } else {
      setEmpresasFiltradas([])
      setDataFiltros((prev) => {
        return {
          ...prev,
          filtros: {
            ...prev.filtros,
            centroCostosId: null,
          },
        }
      })
    }
  }

  const manejarEmpresaSeleccionada = (empresa) => {
    setEmpresaSeleccionada({
      ...empresaSeleccionada,
      nombreEmpresa: empresa.Nombre,
    })
    setDataFiltros((prev) => {
      return {
        ...prev,
        filtros: {
          ...prev.filtros,
          centroCostosId: empresa.Id,
        },
      }
    })
  }
  const manejarCambioDePagina = (numeroPagina) => {
    setDataFiltros((prev) => {
      return {
        ...prev,
        pagina: numeroPagina,
      }
    })
  }
  const filtrarInformacion = () => {
    setActualizarInformacion(!actualizarInformacion)
  }

  const limpiarFiltros = () => {
    const filtros = filtrosIniciales
    if (esMedico) filtros.filtros.empresasIds = empresasIds
    setDataFiltros(filtros)
    filtrarInformacion()
    setEmpresaSeleccionada({
      ...empresaSeleccionada,
      nombreEmpresa: '',
    })
    setEmpresasFiltradas([])
  }

  const manejarCerrarModal = () => {
    contextoAplicacion.setModal({
      abierto: false,
      titulo: '',
      contenido: '',
      botones: [],
    })
  }

  const filtrosExternos = [
    {
      id: 1,
      estilos: 'w-2/12',
      titulo: 'No de documento',
      tipo: 'text',
      funcion: (e) => manejarCambioEnFiltro(e),
      nombre: 'documento',
      formato: 'input',
      valor: dataFiltros.filtros.documento,
    },
    {
      id: 8,
      estilos: 'w-2/12',
      titulo: 'Nombre',
      tipo: 'text',
      funcion: (e) => manejarCambioEnFiltro(e),
      nombre: 'nombres',
      formato: 'input',
      valor: dataFiltros.filtros.nombres,
    },
    {
      id: 9,
      estilos: 'w-2/12',
      titulo: 'Apellido',
      tipo: 'text',
      funcion: (e) => manejarCambioEnFiltro(e),
      nombre: 'apellidos',
      formato: 'input',
      valor: dataFiltros.filtros.apellidos,
    },
    {
      id: 2,
      estilos: 'w-2/12',
      titulo: 'Fecha inicial',
      tipo: 'date',
      funcion: (e) => manejarCambioEnFiltro(e),
      nombre: 'fechaDesde',
      fechaMaxima: moment(dataFiltros.filtros.fechaHasta).format('YYYY-MM-DD'),
      formato: 'input',
      valor:
        dataFiltros.filtros.documento ||
        dataFiltros.filtros.nombres ||
        dataFiltros.filtros.apellidos
          ? ''
          : moment(dataFiltros.filtros.fechaDesde).format('YYYY-MM-DD'),
      estiloPersonalizado: `${
        dataFiltros.filtros.documento ||
        dataFiltros.filtros.nombres ||
        dataFiltros.filtros.apellidos
          ? 'pointer-events-none bg-cendiatra-gris-4'
          : ''
      }`,
    },
    {
      id: 3,
      estilos: 'w-2/12',
      titulo: 'Fecha Final',
      tipo: 'date',
      funcion: (e) => manejarCambioEnFiltro(e),
      nombre: 'fechaHasta',
      fechaMinima:
        moment(dataFiltros.filtros.fechaDesde).format('YYYY-MM-DD') ===
        moment().format('YYYY-MM-DD')
          ? ''
          : moment(dataFiltros.filtros.fechaDesde).format('YYYY-MM-DD'),
      fechaMaxima: moment().format('YYYY-MM-DD'),
      formato: 'input',
      valor:
        dataFiltros.filtros.documento ||
        dataFiltros.filtros.nombres ||
        dataFiltros.filtros.apellidos
          ? ''
          : moment(dataFiltros.filtros.fechaHasta).format('YYYY-MM-DD'),
      estiloPersonalizado: `${
        dataFiltros.filtros.documento ||
        dataFiltros.filtros.nombres ||
        dataFiltros.filtros.apellidos
          ? 'pointer-events-none bg-cendiatra-gris-4'
          : ''
      }`,
    },
    {
      id: 4,
      estilos: 'w-3/12',
      titulo: 'Centro de Costos O Empresa Usuaria',
      tipo: 'text',
      funcion: (e) => manejarCambioEnFiltro(e),
      nombre: 'empresaUsuaria',
      funcionManejarCambio: (e) => filtrarEmpresas(e),
      funcionOpcionSeleccionada: (e) => manejarEmpresaSeleccionada(e),
      formato: 'autocompletar',
      informacionFiltrada: empresasFiltradas,
      valorCampo: empresaSeleccionada?.nombreEmpresa,
    },
    {
      id: 5,
      estilos: 'w-2/12',
      titulo: 'Estado',
      tipo: 'text',
      funcion: (e) => manejarCambioEnFiltro(e),
      nombre: 'estadoId',
      formato: 'lista',
      opciones: estadosAtencion,
      valor: dataFiltros.filtros.estadoId,
    },
    {
      id: 6,
      estilos: 'w-2/12',
      titulo: 'Sede',
      tipo: 'text',
      funcion: (e) => manejarCambioEnFiltro(e),
      nombre: 'sedeId',
      fechaMinima: '',
      formato: 'lista',
      opciones: sedesCendiatra,
      valor: dataFiltros.filtros.sedeId,
    },
  ]

  return (
    <div className="w-full flex justify-center items-center ">
      <div className="w-full flex justify-center items-center">
        <ListadoOrdenesYAtenciones
          funcionObtenerDatos={FachadaObtenerAtencionesGestionAtenciones}
          datosTabla={listaOrdenes}
          actualizarDatosTabla={setListaOrdenes}
          filtrosExternos={filtrosExternos}
          funcionFiltrar={filtrarInformacion}
          informacionPaginacion={informacionPaginacion}
          funcionCambiarPagina={manejarCambioDePagina}
          mostrarAtenciones={true}
          funcionLimpiarFiltros={limpiarFiltros}
          tamanoPagina={dataFiltros.tamano}
        />
      </div>
    </div>
  )
}

export default GestionAtenciones
